export default "__VITE_ASSET__4ec90bd1__"